import {IServiceFactory} from "../../../service-factory.interface";
import {CknSsrBase} from "./ckn-ssr-base";


export default class BcdiSsrType extends CknSsrBase {
    constructor(services: IServiceFactory) {
        super('BCDI', services);
    }
}
